import { render, staticRenderFns } from "./AllRequestDocuments.vue?vue&type=template&id=70156ca4&scoped=true"
import script from "./AllRequestDocuments.vue?vue&type=script&lang=js"
export * from "./AllRequestDocuments.vue?vue&type=script&lang=js"
import style0 from "./AllRequestDocuments.vue?vue&type=style&index=0&id=70156ca4&prod&lang=scss&scoped=true"
import style1 from "./AllRequestDocuments.vue?vue&type=style&index=1&id=70156ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70156ca4",
  null
  
)

export default component.exports